import stage from '../stage';
import { introScreen } from './intro/screen';
import { testScreen } from './test/screen';
import { summaryScreen } from './summary/screen';
import Test from '../test';

const screens = [ introScreen, testScreen, summaryScreen ];

const screensContainer = new PIXI.Container();
stage.addChild(screensContainer);
screensContainer.position.set(20, 20);
screens.forEach(screen => screensContainer.addChild(screen));
showScreen(introScreen);

Test.eventEmitter.on('TEST_START', test => {
  showScreen(testScreen);
});

Test.eventEmitter.on('TEST_END', test => {
  if ( test.currentQuestionIndex === 0 ) {
    return test.exit();
  }
  showScreen(summaryScreen);
});

Test.eventEmitter.on('TEST_EXIT', test => {
  showScreen(introScreen);
});

function showScreen( nextScreen ) {
  screens.forEach(screen => screen.visible = screen === nextScreen);
}
